import { useEffect, useMemo, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

import {
  CustomerModel,
  ServiceModel,
  ServiceModelDto
} from '../../../domain/models'
import { fetchCustomer, fetchListServiceByCPF } from '../../../main/usecases'

import { useModalBox, useOnChangeDetect } from '../../contexts'
import { maskCpf } from '../../utils'
import { FactCard, ServiceForm, SessionCard, SubHeader } from '../../components'
import moment from 'moment'
import {
  BirthdateSvg,
  IconEditSvg,
  PatientSvg,
  ProfissionSvg,
  SchoolSvg
} from '../../assets/icons/svgComponents'

import * as S from './styles'
import AssesmentCard from '../../components/timeline/cards/assesment-card'
import Toolbar from './tool-bar'
// import NotesForm from '../../components/timeline/modal/notes'
import ObjetiveForm from '../../components/timeline/modal/objectives'
import { fetchListToSession } from '../../../main/usecases/services/session'
import { fetchListToRelevantFact } from '../../../main/usecases/services/relevantfact'
import { SessionModel } from '../../../domain/models/session'
import { RelevantFactModel } from '../../../domain/models/relevant-fact'
import { fetchListToAssessment } from '../../../main/usecases/services/assesment'
import { AssessmentModel } from '../../../domain/models/assessment'
import ReactJoyride from 'react-joyride'
import theme from '../../styles/theme'
import { formatDate } from '../../components/timeline/modal/fact'

const MedicalRegister = ({ match }: any) => {
  const [customer, setCustomer] = useState<CustomerModel>()
  const [servicesList, setServicesList] = useState<ServiceModelDto[]>([])
  const [runTuto, setRunTuto] = useState<boolean>(false)
  const [selectedService, setSelectedService] =
    useState<ServiceModelDto | null>()
  const [listArtefacs, setListArtefacts] = useState<any[]>()
  // const [listToAssessment] = useState<ServiceModel[]>()
  const { modalBox } = useModalBox()
  const { refresh } = useOnChangeDetect()
  const [loading, setloading] = useState<boolean>(false)
  const location = useLocation()
  // const handleOpenNewServiceModal = () => {
  //   modalBox(<ServiceForm value={customer} />, 'Anotações Pessoais', '60%')
  // }

  // const handleOpenNotesModal = () => {
  //   modalBox(<NotesForm />, 'Anotações Pessoais', '60%')
  // }

  const handleOpenObjectivesModal = () => {
    modalBox(
      <ObjetiveForm
        service={selectedService}
        setSelectService={setSelectedService}
      />,
      'Editar Demandas e Objetivos',
      '60%'
    )
  }

  const handleOpenEditModal = (service: ServiceModel) => {
    modalBox(
      <ServiceForm value={customer} service={service} />,
      'Editar serviço',
      '34%',
      '86%'
    )
  }

  const activeRouteDataRegistration = useMemo(() => {
    if (
      window.location.pathname ===
      `/meus-pacientes/${match?.params?.id}/dados-cadastrais`
    ) {
      return true
    }
    return false
  }, [match?.params?.id])

  const activeRouteService = useMemo(() => {
    if (
      window.location.pathname ===
      `/meus-pacientes/${match?.params?.id}/prontuario`
    ) {
      return true
    }
    return false
  }, [match?.params?.id])

  const loadServices = async (cpf: string) => {
    try {
      const list = await fetchListServiceByCPF({
        cpf: `${cpf}`
      }).load()
      setServicesList(list)

      const serviceIdQuery = new URLSearchParams(location.search).get(
        'serviceId'
      )
      if (serviceIdQuery) {
        setSelectedService(
          list.find(
            (s: ServiceModelDto) =>
              Number(s.cdServico) === Number(serviceIdQuery)
          )
        )
      } else {
        setSelectedService(list[0])
      }
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    ;(async () => {
      try {
        const responseToCustomer = await fetchCustomer({
          id: match?.params?.id
        }).load()
        setCustomer(responseToCustomer)
        if (responseToCustomer?.cpf) {
          await loadServices(responseToCustomer?.cpf)
        }
      } catch (error) {
        console.log(error)
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [match.params, refresh])

  moment.locale('pt')

  const joinListToService = (
    session: SessionModel[],
    fact: RelevantFactModel[],
    assesment: any[]
  ): any => {
    const all = [
      ...session.map((el: SessionModel) => ({
        ...el,
        data: moment(new Date(`${el?.dataInicio}`)).unix()
      })),
      ...fact.map((el: RelevantFactModel) => ({
        ...el,
        data: moment(formatDate(el.dataFatoRelevante)).unix()
      })),
      ...assesment.map((el: AssessmentModel) => ({
        ...el,
        data: moment(el.dataFinal).unix()
      }))
    ]

    return all.sort(function (a: any, b: any): any {
      return b.data - a.data
    })
  }

  useEffect(() => {
    ;(async () => {
      try {
        setloading(true)
        if (
          selectedService &&
          servicesList.find(
            (el: any) => selectedService.cdServico === el.cdServico
          )
        ) {
          const sessionsData = await fetchListToSession(
            selectedService?.cdServico
          ).load()
          console.log(sessionsData)
          const relevantFactData = await fetchListToRelevantFact(
            selectedService?.cdServico
          ).load()
          // console.log(joinListToService(sessionsData, relevantFactData, []))
          const responseToAssessment = await fetchListToAssessment(
            selectedService?.cdServico
          ).load()
          if (
            !sessionsData.length &&
            !relevantFactData.length &&
            !responseToAssessment.length
          ) {
            setRunTuto(true)
          } else {
            setRunTuto(false)
          }
          setListArtefacts(
            joinListToService(
              sessionsData,
              relevantFactData,
              responseToAssessment
            )
          )
        }
        setloading(false)
      } catch (error) {
        setloading(false)
        console.log(error)
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [match.params.id, selectedService, refresh])

  return (
    <S.Wrapper>
      {customer && (
        <SubHeader name={customer.nome} cpf={maskCpf(customer.cpf)} />
      )}

      <S.CardContainer>
        <S.HeaderContainer>
          <S.LinksContainer>
            <Link
              to={`/meus-pacientes/${match?.params?.id}/dados-cadastrais`}
              className={activeRouteDataRegistration ? 'active' : ''}
            >
              Dados Cadastrais
            </Link>
            <Link
              to={`/meus-pacientes/${match?.params?.id}/prontuario`}
              className={activeRouteService ? 'active' : ''}
            >
              Prontuário
            </Link>
          </S.LinksContainer>
        </S.HeaderContainer>
        <S.ContainerCards>
          <S.LeftSide>
            <S.PatientCard>
              <S.TitleCard>Identificação do paciente</S.TitleCard>
              <S.LabelCard>
                <label>
                  <PatientSvg />
                  Paciente
                </label>
                <p>{customer?.nome}</p>
              </S.LabelCard>
              <S.LabelCard>
                <label>
                  <BirthdateSvg />
                  Nascimento
                </label>
                <p>{moment(customer?.dataNascimento).format('DD/MM/YYYY')}</p>
              </S.LabelCard>
              <S.LabelCard>
                <label>
                  <ProfissionSvg />
                  Profissão
                </label>
                <p>{customer?.profissao || 'Desconhecida'}</p>
              </S.LabelCard>
              <S.LabelCard>
                <label>
                  <SchoolSvg />
                  Escolaridade
                </label>
                <p>{customer?.escolaridade?.escolaridade || 'Desconhecida'}</p>
              </S.LabelCard>
            </S.PatientCard>
            {selectedService && (
              <S.DescriptionCard>
                <S.TitleCard>
                  Demandas e Objetivos
                  <S.ActionButtonCard
                    onClick={() => handleOpenObjectivesModal()}
                  >
                    <IconEditSvg />
                  </S.ActionButtonCard>
                </S.TitleCard>
                <S.ParagraphCard>
                  {selectedService?.demandaObjetivo}
                </S.ParagraphCard>
              </S.DescriptionCard>
            )}
            {/* <S.DescriptionCard>
              <S.TitleCard>
                Anotações pessoais
                <S.ActionButtonCard onClick={() => handleOpenNotesModal()}>
                  <IconEditSvg />
                </S.ActionButtonCard>
              </S.TitleCard>
              <S.ParagraphCard>
                Na sessão de hoje consegui identificar alguns sintomas de
                ansiedade através da fala e comportamento da paciente. Tal como:
                inquietação e medos.
              </S.ParagraphCard>
            </S.DescriptionCard> */}
          </S.LeftSide>
          <S.RightSide>
            <Toolbar
              customer={customer}
              services={servicesList}
              setSelectedService={setSelectedService}
              selectedService={selectedService}
              setServicesList={setServicesList}
            />
            {!selectedService && (
              <div className="none-service">Nenhum serviço selecionado</div>
            )}
            {!!selectedService && !listArtefacs?.length && (
              <div className="none-service">
                Nada ainda foi criado neste serviço
              </div>
            )}
            {loading && <div className="none-service">carregando...</div>}
            {!loading && !!selectedService && !!listArtefacs?.length && (
              <div>
                {listArtefacs?.map(
                  (
                    el: RelevantFactModel | SessionModel | AssessmentModel | any
                  ): JSX.Element => {
                    if (el?.cdSessao) {
                      return (
                        <SessionCard
                          session={el}
                          patient={customer}
                          service={selectedService}
                        />
                      )
                    }
                    if (el?.cdFatoRelevante) {
                      return (
                        <FactCard
                          relevantFact={el}
                          patient={customer}
                          service={selectedService}
                        />
                      )
                    }
                    if (el?.cdAvaliacaoPsicologica) {
                      return (
                        <AssesmentCard
                          handleOpenEditModal={handleOpenEditModal}
                          idCustomer={match?.params?.id}
                          patient={customer}
                          assessment={el}
                          service={selectedService}
                        />
                      )
                    }
                    return <></>
                  }
                )}
                {/* <SessionCard />
                <AttachmentCard />
                <FactCard /> */}
                {/* {!!listToServices?.length && (
                  <AssesmentCard
                    handleOpenEditModal={handleOpenEditModal}
                    idCustomer={match?.params?.id}
                    rows={listToServices}
                  />
                )} */}
              </div>
            )}
          </S.RightSide>
        </S.ContainerCards>
        <ReactJoyride
          run={runTuto}
          steps={[
            {
              content: <p>Clique aqui para adicionar uma nova sessão</p>,
              locale: {
                last: 'Ok',
                close: 'Ok'
              },
              styles: {
                buttonClose: {
                  backgroundColor: theme.colors.primary
                }
              },
              showSkipButton: false,
              hideCloseButton: true,
              hideBackButton: true,
              spotlightPadding: 20,
              disableBeacon: true,
              target: '.add-session'
            }
          ]}
          styles={{
            options: {
              zIndex: 10000
            }
          }}
          hideCloseButton
          continuous={false}
        />
      </S.CardContainer>
    </S.Wrapper>
  )
}
export default MedicalRegister
